<template>
  <div>
    <form>
      <legend>
        {{$t('get_your_receipt')}}
      </legend>
      <div class="rows">
        <dropdown ref="citySelect" :options="cities" :placeholder="$t('choose_city')" v-model="cityCode"/>
      </div>
      <div class="rows">
        <dropdown ref="locationSelect" :options="locations" :placeholder="$t('choose_location')" v-model="locationId" :disabled="!this.cityCode"/>
      </div>
      <div class="rows">
        <datepicker :placeholder="$t('transaction_date')" v-model="transactionDate" :language="this.$root.$children[0].dateLocale"/>
      </div>

      <div id="cardInfo">
        <div class="rows">
          <credit-card-select ref="cardtypeSelect" id="cardType" :placeholder="$t('card_type')" v-model="cardType"/>
          <label v-if="$mq === 'desktop'" for="last4digits">{{$t('last_4_digits')}}</label><input id="last4digits" type="text" maxlength="4" v-model="last4digits" :placeholder="$mq !== 'desktop' ? $t('last_4_digits') : ''">
        </div>
<!--        <div class="rows">-->
<!--          <datepicker id="cardExp" v-html :placeholder="$t('card_exp')" :minimumView="'month'" :format="'MM/yy'" v-model="cardExpiration" style="width: 50%" :language="this.$root.$children[0].dateLocale"/>-->
<!--        </div>-->
      </div>

      <div class="rows">
        <label class="checkbox-label" for="receiptCopy"> {{$t('email-copy')}}
          <input id="receiptCopy" type="checkbox" v-model="emailCopy">
          <span class="checkmark"/>
        </label>
      </div>
      <div class="rows">
        <input id="emailAddr" class="textInput" type="text" :placeholder="$t('email_address')" v-model="emailAddress">
      </div>
      <div id="buttons-div" class="rows">
        <span>
          <form-button id="button-reset" @click.native="resetValues">{{$t('buttons.reset')}}</form-button>
          <form-button @click.native="getReceipt" :disabled="!validated">{{$t('buttons.get-receipt')}}</form-button>
        </span>
      </div>
    </form>

    <div id="reporting">
      <component :is="reportingComponent" v-bind="reportingProperties">{{reportingSlot}}</component>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import CreditCardSelect from "./CreditCardSelect";
  import Dropdown from "./Dropdown"
  import Datepicker from 'vuejs-datepicker'
  import FormButton from "./FormButton";
  import Notification from "./Notification";
  import PulseLoader from 'vue-spinner/src/PulseLoader'
  import vSelect from 'vue-select'

  export default {
    name: "Receipt",
    components: {axios, CreditCardSelect, Dropdown, Datepicker, FormButton, Notification, PulseLoader, vSelect},
    data() {
      return {
        cardExpiration: '',
        cardType: '',
        cities: [],
        cityCode: '',
        emailAddress: '',
        emailCopy: false,
        last4digits: '',
        locationId: '',
        locations: [],
        locationType: '',
        reportingComponent: '',
        reportingProperties: {},
        reportingSlot: '',
        transactionDate: '',
        api: {
          url: 'https://pulsar.parkeonsmartcenter.com/asset_interface/asset_service.php',
          config: {
            auth: {
              username: 'webportal',
              password: '>),xj26+5=HAVaQy'
            }
          }
        },
      }
    },
    mounted() {
      this.getCities();
    },
    watch: {
      cityCode () {
        this.cities.forEach((city, index) => {
          if (city.value === this.cityCode) {
            this.locationType = city.locationType
            this.getLocations()
          }
        })
      }
    },
    computed: {
      validated () {
        return Boolean(this.cityCode
          && this.locationId
          && this.transactionDate
          && this.cardType
          // && this.cardExpiration
          && this.last4digits)
      }
    },
    methods: {
      emailReceipt () {
        let body = {
          'service_code' : 4,
          'container': 'receipts',
          'clause': '',
          'action': 'email',
          'data': ''
        }
        axios.post(this.api.url, body, this.api.config)
          .then(response => {
            return response.data
          })
          .catch(response => {
            return []
          });
      },
      getCities () {
        let body = {
          'service_code' : 4,
          'container': 'cities',
          'clause': '',
          'action': 'select',
          'data': ''
        }
        axios.post(this.api.url, body, this.api.config)
          .then(response => {
            this.cities = response.data.map((city) => {
              return {label:city.clientname, value:city.city_code, locationType:city.next_container}
            })
          });
      },
      getLocations () {
        let body = {
          'service_code' : 4,
          'container': this.locationType,
          'clause': {'city_code':this.cityCode},
          'action': 'select',
          'data': ''
        }
        axios.post(this.api.url, body, this.api.config)
          .then(response => {
            this.locations = response.data.map((location) => {
              return {
                label: location[this.locationType.slice(0, -1) + '_name'],
                value: location[this.locationType.slice(0, -1) + '_id']
              }
            })
          })
          .catch(response => {
            return ''
          })
      },
      getReceipt () {
        let locationField = this.locationType+'_id'
        let body = {
          'service_code' : 4,
          'container': 'receipts',
          'clause': {
            "card_expiration": this.cardExpiration,
            "card_type": this.cardType,
            locationField: this.locationId,
            "city_code": this.cityCode,
            "email": this.emailAddress,
            "last_4_digits": this.last4digits,
            "sale_date": this.transactionDate,
          },
          'action': this.emailCopy ? 'email' : 'print',
          'data': ''
        }

        // Start loader
        window.scrollTo(0,document.body.scrollHeight);
        this.reportingComponent = PulseLoader
        this.reportingProperties = {
          color: '#8cb6c0'
        }

        axios.post(this.api.url, body, this.api.config)
          .then(response => {
            this.reportingComponent = Notification
            this.reportingProperties = {
              level: 'success',
              htmlMessage: this.$t('response.receipt.200', {pdfUrl: response.data.receipt_url})
            }
          })
          .catch(error => {
            this.reportingComponent = Notification

            switch (error.response.status) {
              case 404:
                this.reportingProperties = {
                  level:'error',
                  htmlMessage: this.$t('response.receipt.404')
                }
                this.reportingSlot = this.$t('response.receipt.404')
                break
              default:
                this.reportingProperties = {'level':'error'}
                this.reportingSlot = this.$t('response.400')
            }
          });
      },
      resetValues () {
        this.cardExpiration = ''
        this.cardType = ''
        this.cityCode = ''
        this.emailAddress = ''
        this.emailCopy = false
        this.last4digits = ''
        this.locationId = ''
        this.locations = []
        this.locationType = ''
        this.reportingComponent = ''
        this.reportingProperties = {}
        this.reportingSlot = ''
        this.transactionDate = ''
        this.$refs.citySelect.selected = null
        this.$refs.locationSelect.selected = null
        this.$refs.cardtypeSelect.selected = null
      },
    }
  }
</script>

<style scoped>
  form {
    width: 100%;
    max-width: 580px;
    font-size: 17px !important;
    color: black;
  }

  legend {
    font-size: 38px;
    color: #ba4c3e;
    font-weight: 600;
    padding-bottom: 10px;
  }

  .checkbox-label {
    padding-left: 30px;
    cursor: pointer;
    position: relative;
  }

  .checkbox-label input[type=checkbox] {
    height: 15px;
    width: 15px;
    position: absolute;
    top: 29%;
    left: 0;
    opacity: 0;
    cursor: pointer;;
  }

  .checkbox-label input[type=checkbox]:checked ~ .checkmark {
    background-color: #ba4c3e;
  }

  .checkmark {
    height: 16px !important;
    width: 16px !important;
    position: absolute;
    top: 29%;
    left: 0;
    background-color: white;
    border: 1px solid #ccc !important;
  }
  .checkbox-label input:checked ~ .checkmark:after {
    display: block;
  }

  .checkmark:after {
    content: "";
    display: none;
    position: absolute;
    left: 4px;
    top: 0;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .mobile #buttons-div,
  .tablet #buttons-div{
    margin-top: 5px;
  }

  .mobile #buttons-div button,
  .tablet #buttons-div button{
    margin-left: 8px;
    min-width: unset;
  }

  .mobile #last4digits,
  .tablet #last4digits{
    width: 40%;
  }

  .rows {
    height: 63px;
    padding-top: 13px;
    width: 100%;
    box-sizing: border-box;
    display: block;
  }

  .rows * {
    height: 50px;
    line-height: 50px;
    display: inline-block;
    border: none;
    float: left;
  }

  #button-reset {
    color: #244148;
    background-color: transparent;
    border: 1px solid #244148;
  }

  #buttons-div {
    margin-top: 40px;
  }

  #buttons-div span {
    float: right;
  }

  #buttons-div button {
    margin-left: 15px;
    min-width: 150px;
  }

  #cardInfo {
    padding: 20px 0 10px 0;
  }

  #cardType {
    width: 50%;
  }

  #cardType + label {
    font-size: 17px;
    width: 22%;
    text-align: right;
    padding-right: 2%;
  }

  #last4digits {
    width: 22%;
    padding-left: 3%;
    float: right;
  }

  #reporting {
    width: 100%;
    padding-top: 50px;
    display: flex;
    justify-content: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/Receipt.vue